(function () {
  'use strict';

  angular.module('ringbaPortal').component('whitelabelEditor', {
    bindings: {
      closeEditor: '&'
    },
    controller: WhitelabelEditorController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/whitelabel-editor/whitelabel-editor.view.html'
  });

  function WhitelabelEditorController(
    _,
    $filter,
    $q,
    $scope,
    $timeout,
    $uibModal,
    accountsService,
    toaster,
    utils,
    whitelabelEditorService,
    whitelabelService
  ) {
    'ngInject';

    const vm = this;

    const defaultThemeObject = {
      default: { }
    };

    let oldDarkValues = {};
    let oldLightValues = {};
    let brandName = '';
    let productionTheme = null;

    vm.expandEditor = true;
    vm.colorChanged = false;
    vm.showPreviewTooltip = true;

    vm.$onInit = onInit;
    vm.toggleEditor = toggleEditor;
    vm.onLightDarkToggle = onLightDarkToggle;
    vm.resetThemeToDefaultValues = resetThemeToDefaultValues;
    vm.onThemeColorChange = onThemeColorChange;
    vm.onLogoUpload = onLogoUpload;
    vm.onFaviconUpload = onFaviconUpload;
    vm.saveWhitelabelTheme = saveWhitelabelTheme;
    vm.confirmEditorClose = confirmEditorClose;
    vm.cancelModal = cancelModal;
    vm.resetToLastSavedTheme = resetToLastSavedTheme;
    vm.resetToRingbaTheme = resetToRingbaTheme;
    vm.closeResetPopover = closeResetPopover;
    vm.handlePublishButton = handlePublishButton;
    vm.confirmPublishTheme = confirmPublishTheme;
    vm.onTextValueChange = onTextValueChange;

    function onInit() {
      defaultThemeObject.default[whitelabelEditorService.getBrandFaviconCssVariable()] = whitelabelEditorService.getBrandFaviconDefaultValue();
      vm.componentsToChange = whitelabelEditorService.getComponentsList();
      _getWhitelabelSettings();
      _loadAccount();
      _setListenerForStateChangeOrRefresh();
    }

    function handlePublishButton() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/whitelabel-editor/theme-publish-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function confirmPublishTheme() {
      return _saveWhitelabelTheme().then(function() {
        return whitelabelService.publishThemeChanges(accountsService.currentAccountId);
      }).then(function(response) {
        productionTheme = response.data.theme;
        _enablePublisherButton(vm.whitelabelThemeOriginal, productionTheme);
        toaster.pop('success', $filter('translate')('WHITELABEL_PUBLISH_SUCCESS'));
        cancelModal();
        vm.closeEditor();
      }).catch(utils.errorHandler);
    }

    function toggleEditor() {
      vm.expandEditor = !vm.expandEditor;
      vm.showPreviewTooltip = false;
    }

    function onLightDarkToggle(isLightTheme) {
      if (vm.isLightTheme === isLightTheme) {
        return;
      }
      vm.isLightTheme = isLightTheme;
      const logoBase64 = whitelabelEditorService.getLogoBase64FromTheme(vm.whitelabelThemeCopy);
      const faviconBase64 = whitelabelEditorService.getFaviconBase64FromTheme(vm.whitelabelThemeCopy);
      const loginWelcomeMessage = whitelabelEditorService.getLoginWelcomeMessageFromTheme(vm.whitelabelThemeCopy);
      let defaultTheme = angular.copy(defaultThemeObject);
      if (isLightTheme) {
        oldDarkValues = vm.whitelabelThemeCopy;
        defaultTheme = _.isEmpty(oldLightValues) ? defaultTheme : oldLightValues;
      } else {
        oldLightValues = vm.whitelabelThemeCopy;
        defaultTheme = _.isEmpty(oldDarkValues) ? defaultTheme : oldDarkValues;
      }
      defaultTheme = whitelabelEditorService.setLogoBase64ToTheme(defaultTheme, logoBase64);
      defaultTheme = whitelabelEditorService.setFaviconBase64ToTheme(defaultTheme, faviconBase64);
      defaultTheme = whitelabelEditorService.setLoginWelcomeMessageFromTheme(defaultTheme, loginWelcomeMessage);
      _setThemeToCopy(defaultTheme);
    }

    function closeResetPopover() {
      vm.showResetOptions = false;
    }

    function resetToRingbaTheme() {
      let defaultTheme = angular.copy(defaultThemeObject);
      defaultTheme = whitelabelEditorService.setLogoBase64ToTheme(defaultTheme, whitelabelEditorService.getLogoBase64FromTheme(vm.whitelabelThemeOriginal));
      defaultTheme = whitelabelEditorService.setFaviconBase64ToTheme(defaultTheme, whitelabelEditorService.getFaviconBase64FromTheme(vm.whitelabelThemeOriginal));
      _setThemeToCopy(defaultTheme);
      closeResetPopover();
    }

    function resetToLastSavedTheme() {
      let defaultTheme = angular.copy(vm.whitelabelThemeOriginal);
      defaultTheme = whitelabelEditorService.setLogoBase64ToTheme(defaultTheme, whitelabelEditorService.getLogoBase64FromTheme(vm.whitelabelThemeOriginal));
      defaultTheme = whitelabelEditorService.setFaviconBase64ToTheme(defaultTheme, whitelabelEditorService.getFaviconBase64FromTheme(vm.whitelabelThemeOriginal));
      _setThemeToCopy(defaultTheme);
      closeResetPopover();
    }

    // Show popover to show the option to either reset the theme to the last saved one or the default Ringba theme
    // The popover will be shown only if the last saved theme version(light/dark) matches user's current preference(light/dark)
    function resetThemeToDefaultValues() {
      if (whitelabelEditorService.checkThemeIsLight(vm.whitelabelThemeOriginal) === vm.isLightTheme && !vm.showResetOptions) {
        _showResetPopover();
      } else if (vm.showResetOptions) {
        closeResetPopover();
      } else {
        resetToRingbaTheme();
      }
    }

    function onThemeColorChange(cssVariables, value, componentName, propertyName) {
      const defaultTheme = vm.whitelabelThemeCopy;
      _.forEach(cssVariables, function(cssVar) {
        if (whitelabelEditorService.checkDefaultCSSVarValue(componentName, propertyName) === value && !vm.whitelabelThemeOriginal['default'][cssVar]) {
          delete defaultTheme.default[cssVar];
        } else {
          defaultTheme.default[cssVar] = value.indexOf('url') > -1 || value.indexOf('base64') > -1 ? value : '#' + value;
        }
      });

      _setThemeToCopy(defaultTheme);
    }

    function onTextValueChange(textValue, cssVariables) {
      const defaultTheme = vm.whitelabelThemeCopy;
      _.forEach(cssVariables, function(cssVar) {
        defaultTheme.default[cssVar] = '"' + textValue + '"';
      });
      _setThemeToCopy(defaultTheme);
    }

    function onLogoUpload($file, $invalidFiles) {
      if ($file) {
        utils.readImage($file).then(function(base64Data) {
          onThemeColorChange([whitelabelEditorService.getBrandLogoCssVariable()], 'url("' + base64Data + '")');
        });
      } else if ($invalidFiles && $invalidFiles.length) {
        _showUploadErrorMessage('LOGO', $invalidFiles[0].$errorMessages);
      }
    }

    function onFaviconUpload($file, $invalidFiles) {
      if ($file) {
        utils.readImage($file).then(function(base64Data) {
          onThemeColorChange([whitelabelEditorService.getBrandFaviconCssVariable()], '"' + base64Data + '"');
        });
      } else if ($invalidFiles && $invalidFiles.length) {
        _showUploadErrorMessage('FAVICON', $invalidFiles[0].$errorMessages);
      }
    }

    function saveWhitelabelTheme() {
      return _saveWhitelabelTheme().then(function() {
        toaster.pop('success', $filter('translate')('WHITELABEL_SAVE_SUCCESS'));
      });
    }

    function confirmEditorClose(confirmClose) {
      if (confirmClose) {
        cancelModal();
        _removeAllUIChangesAndCloseEditor();
        return $q.when();
      }
      if (!vm.colorChanged) {
        _removeAllUIChangesAndCloseEditor();
      } else {
        confirmCloseModal();
      }
    }

    function confirmCloseModal() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/whitelabel-editor/whitelabel-close-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function _saveWhitelabelTheme() {
      vm.savingTheme = true;
      vm.whitelabelThemeCopy.default[whitelabelEditorService.getBrandNameCssVariable()] = brandName ? '"' + brandName + '"' : null;
      return whitelabelService.saveWhitelabelTheme(accountsService.currentAccountId, vm.whitelabelThemeCopy, vm.isLightTheme)
        .then(function(response) {
          vm.whitelabelThemeOriginal = response.data.theme;
          _setThemeToCopy((response.data.theme) || defaultThemeObject);
          _enablePublisherButton(vm.whitelabelThemeOriginal, productionTheme);
        })
        .catch(utils.errorHandler)
        .finally(function() {
          vm.savingTheme = false;
          _enableDisableSaveButton();
        });
    }

    function _setThemeToCopy(defaultTheme) {
      $timeout(function() {
        vm.whitelabelThemeCopy = angular.copy(defaultTheme);
        _enableDisableSaveButton();
      }, 0);
    }

    function _showResetPopover() {
      vm.showResetOptions = true;
    }

    function _removeAllUIChangesAndCloseEditor() {
      if (vm.isSiteFriendlyNamed) {
        _setThemeToCopy(productionTheme);
        vm.isLightTheme = productionTheme.isLightTheme;
      } else {
        _setThemeToCopy(defaultThemeObject);
      }
      $timeout(function() {
        vm.closeEditor();
      }, 0);
    }

    function _enableDisableSaveButton() {
      if (_.isEqual(vm.whitelabelThemeOriginal, vm.whitelabelThemeCopy)) {
        vm.colorChanged = false;
      } else {
        vm.colorChanged = true;
      }
    }

    function _getWhitelabelSettings() {
      return whitelabelService.getWhitelabelSettings(accountsService.currentAccountId).then(function(response) {
        const whiteLabelSettings = response.data.whiteLabelSettings;
        try {
          vm.isSiteFriendlyNamed = whitelabelService.checkWhitelabelSite(whiteLabelSettings);
        } catch {
          vm.isSiteFriendlyNamed = false;
        }
        vm.whitelabelThemeOriginal = (whiteLabelSettings && whiteLabelSettings.stagingTheme) || angular.copy(defaultThemeObject);
        _setThemeToCopy(vm.whitelabelThemeOriginal);
        vm.isLightTheme = vm.whitelabelThemeOriginal.isLightTheme;

        productionTheme = whiteLabelSettings.productionTheme;
        _enablePublisherButton(vm.whitelabelThemeOriginal, productionTheme);

      }).catch(function() {
        _setThemeToCopy(defaultThemeObject);
      });
    }


    function _loadAccount() {
      return accountsService.getAccount(accountsService.currentAccountId)
        .then(function (response) {
          brandName = response.data.account.name;
        });
    }

    function _enablePublisherButton(stagingTheme, themeToPublish) {
      vm.enablePublisherButton = stagingTheme && !_.isEqual(themeToPublish, stagingTheme);
    }

    function _setListenerForStateChangeOrRefresh() {
      window.addEventListener('beforeunload', _confirmOnRefresh);

      $scope.$on(
        '$destroy',
        function () {
          window.removeEventListener('beforeunload', _confirmOnRefresh);
        }
      );
    }

    function _confirmOnRefresh(event) {
      if (vm.colorChanged) {
        // We can't show a custom confirm message when page is refreshed or the tab is closed
        return event.returnValue = 'Confirm leave page';
      }
    }

    function _showUploadErrorMessage(fileUsage, errorMessages) {
      const translationPrefix = 'WHITELABEL_' + fileUsage;
      let baseErrorMessage = $filter('translate')(translationPrefix + '_FAIL_TITLE');
      if (errorMessages.maxSize) {
        baseErrorMessage += ' - ' + $filter('translate')(translationPrefix + '_SIZE');
      }
      if (errorMessages.maxHeight || errorMessages.maxWidth) {
        baseErrorMessage += ' - ' + $filter('translate')(translationPrefix + '_DIMENSIONS');
      }
      toaster.pop({
        type: 'error',
        body: baseErrorMessage,
        bodyOutputType: 'trustedHtml'
      });
    }

  }
})();
